import { render, staticRenderFns } from "./MsgElementSeesionScore.vue?vue&type=template&id=01902e08&scoped=true"
import script from "./MsgElementSeesionScore.vue?vue&type=script&lang=js"
export * from "./MsgElementSeesionScore.vue?vue&type=script&lang=js"
import style0 from "./MsgElementSeesionScore.vue?vue&type=style&index=0&id=01902e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01902e08",
  null
  
)

export default component.exports